const millisecondsPerDay = 24 * 60 * 60 * 1000;

// Rounded up; a deadline already past still counts as the last day.
export const getDaysLeftToReschedule = ({ deadline, currentDate }) =>
  Math.max(1, Math.ceil((deadline - currentDate) / millisecondsPerDay));
